import WhileMyHeartIsStillBeating from "../../../../src/notes/while-my-heart-is-still-beating";
import * as React from 'react';
export default {
  WhileMyHeartIsStillBeating,
  React
};